import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import { FormGroup, Modal, DropdownButton, MenuItem } from 'react-bootstrap';
import { map } from 'lodash';
import AlertDismissable from '../common/AlertDismissable';
import { imageBasePath } from '../../constants/staticData';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class AddUser extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.imageUpload = this.imageUpload.bind(this);
    this.setImageURL = this.setImageURL.bind(this);
    this.state = {
      searchMobile: false,
      leftDropDownVisible: false,
      location: 'User type',
      showSidebar: false,
      uploadImageFile: `${imageBasePath}/pic.png`
    };
    this.initialFormData = {
      name: '',
      email: '',
      password: '',
      phone: '',
      profile_photo: '',
      type_id: '',
      terms: true
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      name: false,
      email: false,
      password: false,
      phone: false,
      type_id: false
    };
  }

  componentWillMount() {
    this.props.actions.hideErrorMessage();
    if (this.props.manageuserReducer.driverTypes.length == 0) {
      this.props.actions.getDriverTypes();
    }
    this.props.actions.hideErrorMessage();
  }

  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }

  componentDidMount() {
    this.props.actions.hideErrorMessage();
  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  toggleMessage(isVisible) {
    this.setState({ messageVisible: isVisible });
  }

  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }

  setImageURL(url) {
    this.setState({ uploadImageFile: url });
  }

  onFieldChange(value, name, key) {
    this.setState({ formError: false });
    this.formData[name] = value;
    this.errors[name] = value ? false : true;
  }
  imageUpload(e) {
    let file = e.target.files[0];
    let errMesg = 'Sorry, your image exceeds the file size limit of 1mb, Try again with another image.';
    let propsFunc = this.props.actions;
    let resp = '';
    let that = this;
    if (file.size >= 25000000) {
      this.props.actions.showErrorMessage(errMesg);
    } else {
      //this.setState({uploadImageFile: file.name});
      this.props.actions.sign_request(file, 'driver', function(response) {
        resp = response;
        //that.setState({uploadImageFile: resp.data.url});
        propsFunc.uploadImageDP(file, resp.data.signed_request, resp.data.url, function() {
          that.setImageURL(resp.data.url);
        });
      });
    }
  }

  onSubmit() {
    var data = null;
    let checkValue = document.getElementsByClassName('form-group');
    let errorMesg = 'please attach a photo to proceed further';
    map(checkValue, function(value, key) {
      data += value.className;
    });
    let checkError = data.indexOf('error') !== -1 ? true : false;
    if (checkError) {
      this.props.actions.showErrorMessage('please correct the errors on this form');
    } else if (this.state.uploadImageFile == `${imageBasePath}/pic.png`) {
      this.props.actions.showErrorMessage(errorMesg);
      // alert('please upload pick before proceeding')
    } else {
      this.formData.phone = (this.formData.phone.indexOf('+971') == -1 ? '+971' : '') + this.formData.phone;
      this.formData.profile_photo = this.state.uploadImageFile;
      this.props.actions.addUser(this.formData, this.props.router);
    }
  }
  dropdownSelect(e) {
    this.setState({ location: e.displayname });
    this.formData['type_id'] = e.id;
  }

  render() {
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const { authReducer, manageuserReducer, commonReducer } = this.props;
    console.log(authReducer.statusMessage.indexOf('garage-id') !== -1);
    return (
      <div>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          noAutoSuggestCall="true"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <div className="main-wrapper">

          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          {/*message*/}
          {/*<Extra message="Your email account has been verified. We are open for service!" />*/}

          <div className="container-fluid main-container">
            <div className="page-sec-header col">

              <div className="overview-heading headrer-left-pod">
                <h5>Add User</h5>
              </div>
            </div>
            <div className="my-account-body">
              {authReducer &&
                authReducer.showErrorMessage &&
                authReducer.statusMessage.indexOf('garage-id') == -1 &&
                <AlertDismissable
                  bsStyle={
                    authReducer.statusMessage.indexOf('succesfully') !== -1 ? 'success error-back' : 'danger error-back'
                  }
                  closeLabel="Close alert"
                  closeAction={this.props.actions.hideErrorMessage}
                >
                  <p> <i className="mdi mdi-block-helper " /> {authReducer.statusMessage} </p>
                </AlertDismissable>}

              <div className="container">
                <div className="row clearfix">
                  <div className="col-xs-3 image-element-wrapper-mob">
                    <div className="image-element image-element-mob">
                      {this.state.uploadImageFile &&
                        !commonReducer.profileImageUploaded &&
                        <img src={this.state.uploadImageFile} className="imageupl" />}
                      {commonReducer.profileImageUploaded &&
                        <div className="c-loader-img">
                          <img
                            className="img-loader-on-upload imageupl loader-back"
                            src={`${imageBasePath}/loader_white.gif`}
                            alt="Upload in progress"
                          />
                        </div>}
                      <label htmlFor="file-upload" className="custom-file-upload file-upload-label-mob">
                        <i className="glyphicon glyphicon-camera" />
                      </label>
                      <input id="file-upload" type="file" accept="image/*" onChange={e => this.imageUpload(e)} />
                    </div>
                  </div>
                  <div className="col-xs-9 form-wrapper">
                    <div className="password-form-info password-form-info-mob">
                      <TextInput
                        type="text"
                        label="Name"
                        name="name"
                        validationError={'Enter your name'}
                        showValidationError={this.errors['name']}
                        validationError="Enter your name"
                        onBlur={this.onFieldChange.bind(this)}
                      />
                      <TextInput
                        type="email"
                        label="Email Address"
                        name="email"
                        validationError="Please enter your email id"
                        showValidationError={this.errors['email']}
                        onChange={this.onFieldChange.bind(this)}
                      />
                      <TextInput
                        type="password"
                        label="Password"
                        name="password"
                        showValidationError={this.errors['password']}
                        validationError="Password should be greater than six digits"
                        onBlur={this.onFieldChange.bind(this)}
                      />
                      <TextInput
                        type="phone"
                        label="Mobile Number"
                        name="phone"
                        showValidationError={this.errors['phone']}
                        validationError="Enter a valid mobile number"
                        onBlur={this.onFieldChange.bind(this)}
                      />
                      <div className="modal-cus-Dd">
                        <DropdownButton
                          bsSize="xsmall"
                          className="selectDropDown modal-dd-text"
                          id="dropdown-size-large"
                          onToggle={e => this.setState({ leftDropDownVisible: e })}
                          onSelect={e => {
                            this.dropdownSelect(e);
                          }}
                          title={
                            <div className="input-group">
                              <span className="selected-car-name">{this.state.location}</span>
                              <i
                                className={
                                  this.state.leftDropDownVisible ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'
                                }
                              />
                            </div>
                          }
                        >
                          {map(manageuserReducer.driverTypes, (info, index) => {
                            return <MenuItem eventKey={info}>{info.displayname}</MenuItem>;
                          })}

                        </DropdownButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">
                <Button
                  btnType="label"
                  btnSize="sm"
                  fontSize={16}
                  label="Save"
                  btnCallBack={() => this.onSubmit(this)}
                  customClass="btn-theme-save hidden-xs"
                />
                <Button
                  btnType="label"
                  btnSize="sm"
                  fontSize={16}
                  label="Cancel"
                  btnCallBack={() => window.history.back()}
                  customClass="btn-theme hidden-xs"
                />
                  <div className="row visible-xs">
                    <div className="col-xs-6 add-veh-mob">
                      <Button
                        btnType="label"
                        btnSize="sm"
                        fontSize={16}
                        label="Save"
                        btnCallBack={() => this.onSubmit(this)}
                        customClass="btn-theme-save add-vehcile-save-btn"
                      />
                    </div>
                    <div className="col-xs-6 add-veh-mob">
                      <Button
                        btnType="label"
                        btnSize="sm"
                        fontSize={16}
                        label="Cancel"
                        btnCallBack={() => window.history.back()}
                        customClass="btn-theme add-vehcile-cancel-btn"
                      />                  
                    </div>
                  </div>
              </div>

            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ManageUser/addUser.jsx